import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  logs: PropTypes.any,
  log: PropTypes.any,
};

class ViewCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      log: {
        emailHtml: '',
        imageData: {},
        durationBreakdown: {},
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let log = nextProps.log;
    if (log.id) {
      log = nextProps.log;
    } else {
      log = nextProps.logs.results[0];
    }
    log.id = (log.id === null) ? 0 : log.id;
    const options = {
      weekday: 'short', year: 'numeric', month: 'short',
      day: 'numeric', hour: '2-digit', minute: '2-digit',
    };
    log.insertDate = new Date(log.insertDate).toLocaleTimeString('en-us', options);
    const emailBodyRegex = /(<!)[^]*/;
    log.emailBody = emailBodyRegex.exec(log.emailHtml)[0];
    this.setState({ log });
  }

  handleCancel() {
    browserHistory.push('/logging/campaigns?page=1');
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div style={{ width: '100%' }}>
        <h2>View Campaign Log</h2>
        <div className="content">
          <div className="float-right">
            <RaisedButton
              style={{ marginRight: '20px' }}
              label="Cancel"
              primary
              onClick={this.handleCancel}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.logs.log.id}
          />
          <br />
          <TextField
            floatingLabelText="Date"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.log.insertDate || ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Source"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.log.source || ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Converter"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.log.converter || ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Email"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.log.email || ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Product Count"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.log.durationBreakdown.product_count || ''}
            style={styles.inputStyle}
          />
        </div>
        <h2>Image Data</h2>
        <div className="content">
          <div style={{ width: '50%', float: 'left' }}>
            <TextField
              floatingLabelText="Width"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.log.imageData.width || ''}
              style={styles.inputStyle}
            />
            <TextField
              floatingLabelText="Height"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.log.imageData.height || ''}
              style={styles.inputStyle}
            />
            <TextField
              floatingLabelText="EXIF Orientation"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.log.imageData.exif || ''}
              style={styles.inputStyle}
            />
            <TextField
              floatingLabelText="Size"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={`${this.state.log.imageData.size} mb` || ''}
              style={styles.inputStyle}
            />
          </div>
          <div>
            <img
              style={{ height: 'auto', width: 'auto', maxWidth: '200px', maxHeight: '200px' }}
              role="presentation"
              src={this.state.log.pageLink}
            />
          </div>
          <div style={{ clear: 'left' }} />
        </div>
        <h2>Process Intervals</h2>
        <div className="content">
          All times shown in seconds
          <br />
          <TextField
            floatingLabelText="Total Process Time"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.log.durationBreakdown.overall || ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Converter Process Time"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.log.durationBreakdown.process_time || ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Inbound Email Delivery Time"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.log.durationBreakdown.inbound_mail_delay || ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Read Campaign Database"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.log.durationBreakdown.get_campaign || ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Process Inbound Email"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.log.durationBreakdown.parse_email || ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Create Thumbnail Image"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={`${this.state.log.durationBreakdown.create_thumb}` || ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Create Overlay Images"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={`${this.state.log.durationBreakdown.convert}` || ''}
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Send Return Email"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={`${this.state.log.durationBreakdown.sendmail}` || ''}
            style={styles.inputStyle}
          />
        </div>
        <h2>Email</h2>
        <div className="content">
          <div style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: this.state.log.emailBody }} />
        </div>
      </div>
    );
  }
}

ViewCampaign.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewCampaign.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    logs: state.logs,
    log: state.logs.log,
  };
}

export default connect(mapStateToProps)(ViewCampaign);



// WEBPACK FOOTER //
// ./src/components/logging/campaigns/ViewCampaign.js